import React from "react";
import { FiEye } from "react-icons/fi";

export default function InvestigationSummary() {
  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-3 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        5. Investigation Summary (Read Only)
      </h3>
      <div className="space-y-3">
        <div className="flex items-center justify-between p-2 rounded-md hover:bg-gray-50 transition border border-gray-100">
          <div>
            <p className="text-xs font-semibold text-gray-800">
              Laboratory Results Summary
            </p>
            <p className="text-[11px] text-teal-600 cursor-pointer hover:underline">
              View Latest Lab Results
            </p>
          </div>
          <button
            type="button"
            className="text-white hover:bg-teal-50 p-2 rounded-full transition"
            title="View Laboratory Results"
          >
            <FiEye />
          </button>
        </div>

        <div className="flex items-center justify-between p-2 rounded-md hover:bg-gray-50 transition border border-gray-100">
          <div>
            <p className="text-xs font-semibold text-gray-800">
              Radiology Summary
            </p>
            <p className="text-[11px] text-teal-600 cursor-pointer hover:underline">
              View Radiology Reports
            </p>
          </div>
          <button
            type="button"
            className="text-white hover:bg-teal-50 p-2 rounded-full transition"
            title="View Radiology Reports"
          >
            <FiEye />
          </button>
        </div>

        <div className="flex items-center justify-between p-2 rounded-md hover:bg-gray-50 transition border border-gray-100">
          <div>
            <p className="text-xs font-semibold text-gray-800">
              Other Significant Findings
            </p>
            <p className="text-[11px] text-teal-600 cursor-pointer hover:underline">
              View Other Reports
            </p>
          </div>
          <button
            type="button"
            className="text-white hover:bg-teal-50 p-2 rounded-full transition"
            title="View Other Reports"
          >
            <FiEye />
          </button>
        </div>
      </div>
    </div>
  );
}
